import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Alert} from 'antd'

/**
 * Bốn mức thông báo dùng chung cả nhóm màn — KHÔNG được dùng lẫn (M16 §0.3).
 *
 * | Mức | Ý nghĩa | Chặn lưu |
 * |---|---|---|
 * | error   | Cấu hình sai, hệ thống không xử lý được | ✅ |
 * | warning | Cấu hình hợp lệ nhưng có rủi ro nghiệp vụ | ❌ |
 * | info    | Trạng thái bình thường, chỉ để người dùng biết | ❌ |
 * | success | Xác nhận thao tác đã xong | ❌ |
 *
 * Quy tắc dễ nhầm nhất: NVL chưa có nhóm riêng là **thông tin** khi công đoạn có nhóm ALL, nhưng
 * là **cảnh báo** khi không có nhóm ALL (BR-M16-28). Cùng một dữ liệu, hai mức khác nhau. Để chung
 * một mức thì người dùng thấy màn hình đỏ liên tục rồi bỏ qua toàn bộ cảnh báo.
 */
function Notice({level, children, action, onAction, className, dismissible}) {
    const [hidden, setHidden] = useState(false)

    if (hidden) return null

    return (
        <Alert
            className={`VcNotice ${className || ''}`}
            type={level}
            showIcon
            /*
             * `closable` chỉ bật khi được yêu cầu rõ ràng.
             *
             * ⚠️ Có thông báo mà đặc tả CẤM ẩn — dải cảnh báo "con số là mức trần" của nguồn Sản
             *    lượng hiện tại (FR-M17-23 / AC-23.1: luôn hiện, không có nút tắt). Để `closable`
             *    mặc định bật thì nó cũng tắt được, và người dùng sẽ đọc con số quá hạn như phần
             *    việc còn lại rồi kết luận thiếu người gấp đôi thực tế.
             */
            closable={dismissible}
            onClose={() => setHidden(true)}
            message={
                <div className="d-flex align-items-start justify-content-between">
                    <div className="VcNoticeBody">{children}</div>
                    {action && onAction && (
                        <button type="button" className="VcNoticeAction" onClick={onAction}>
                            {action}
                        </button>
                    )}
                </div>
            }
        />
    )
}

Notice.propTypes = {
    level: PropTypes.oneOf(['error', 'warning', 'info', 'success']).isRequired,
    children: PropTypes.node.isRequired,
    action: PropTypes.node,
    onAction: PropTypes.func,
    className: PropTypes.string,
    /** Cho phép người dùng ẩn thông báo trong phiên xem này. Mặc định KHÔNG — xem ghi chú ở trên. */
    dismissible: PropTypes.bool,
}

Notice.defaultProps = {dismissible: false}

export default Notice
